import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Prebuilt Font Awesome CSS — Vite resolves and bundles the bundled webfonts,
// so no manual copying into public/ is needed.
import '@fortawesome/fontawesome-free/css/all.min.css';
import './scss/index.scss';
import App from './App.jsx';
import { initBrand } from './brand.js';

// Apply the runtime brand (cached value synchronously, server value async)
// before the first render so the brand paints without a flash.
initBrand();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
